import { tagsFilterAtom } from 'atoms/filters/rsim-products';
import { tagsHintsAtom } from 'atoms/hints/rsim-products';
import { TagsSearchFilter } from 'tags/Components/TagsSearchFilter';

export const TagsSearchInput = () => {
  return <TagsSearchFilter tagsFilterAtom={tagsFilterAtom} tagsHintsAtom={tagsHintsAtom} />;
};
